import { createFileRoute } from "@tanstack/react-router";

import { SiteHostsPanel } from "../features/siteHosts/SiteHostsPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts",
)({
  component: HostsRoute,
});

function HostsRoute() {
  const { accountSlug, siteSlug } = Route.useParams();
  return <SiteHostsPanel accountSlug={accountSlug} siteSlug={siteSlug} />;
}
